export enum ShippingMethod {
    standard = 'Standard',
    expedited = 'Expedited',
  }